import React from 'react'
import { observer, inject } from 'mobx-react'

import anchorScroll from '../../utils/anchorScroll'
import Dropdown from './Dropdown'

const Searchbar = ({ dropdownStore, searchStore, translationStore, guidedIntroductionStore }) => {
  const handleInputChange = e => searchStore.setSearch(e.target.value)

  const resetSearch = () => {
    searchStore.resetSearch()
    dropdownStore.closeDropdown()
  }

  const showSearchDropdown = () => dropdownStore.toggleSearchDropdown()

  const handleKeyPress = (event) => {
    if(event.key === 'Enter') {
      onSearch()
    }
  }

  const onSearch = () => {
    searchStore.restartSearch()
    anchorScroll('top', `/search/${searchStore.searchValue}`)
    resetSearch()
  }

  const onIntroductionClass = () =>  guidedIntroductionStore.showIntroduction && 'z-m1'

  return (
    <div className='search'>
      <div className={`search__inner ${onIntroductionClass()}`} name='step-4'>
        <input
          placeholder={`${translationStore.translate('header_search')}...`}
          name='search'
          className='w-full bg-white lg:bg-grey-lighter'
          style={{minWidth: '205px'}}
          value={searchStore.searchValue}
          onChange={handleInputChange}
          onKeyPress={handleKeyPress}
        />
        <span>
          <i className='fas fa-search' onClick={onSearch}/>
        </span>
      </div>
      {/* <Dropdown active={dropdownStore.showSearchDropdown}></Dropdown> */}
      {/* <div className='btn-icon-grey lg:hidd'  onClick={showSearchDropdown}>
        <i className='fas fa-search block m-auto '/>
      </div> */}
    </div>
  )
}

export default inject('dropdownStore', 'searchStore', 'translationStore', 'guidedIntroductionStore' )(observer(Searchbar))



// WEBPACK FOOTER //
// ./src/components/Header/Searchbar.js